/* eslint-disable no-unused-expressions */
import { connect } from 'react-redux';
import React, { useEffect, useRef } from 'react';
import { skipToContent } from '../../../../shared/actions/skip-to-content';

type Props = {
  skipToContent: Function,
};

const SkipToContent = (props: Props) => {
  const skipToContentContainer = useRef(null);
  const hasTriggered = useRef(false);

  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key !== 'Tab') {
        window.removeEventListener('keydown', handleKeyDown);
        return;
      }
      if (event.key === 'Tab' && !hasTriggered.current) {
        event.preventDefault();
        skipToContentContainer.current?.focus();
        hasTriggered.current = true;
      }
      if (
        event.key === 'Enter' &&
        skipToContentContainer.current === document.activeElement
      ) {
        props.skipToContent(true);
      }
    };

    const handleMouseClick = () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('click', handleMouseClick);
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('click', handleMouseClick);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('click', handleMouseClick);
    };
  }, []);

  const handleSkipToContent = () => {
    props.skipToContent(true);
  };

  const handleFocus = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      className="c-header__skip-to-content-button"
      ref={skipToContentContainer}
      onClick={handleSkipToContent}
      onFocus={handleFocus}
    >
      <p>Skip to content</p>
    </button>
  );
};

const mapDispatchToProps = {
  skipToContent,
};

export default connect(null, mapDispatchToProps)(SkipToContent);
